import React from 'react';
import * as S from './styles';

export const ModalContainer = ({ bgColor, children }) => (
  <S.ModalContainer bgColor={bgColor}>
    <S.ModalContent>{children}</S.ModalContent>
  </S.ModalContainer>
);
